module.exports = __webpack_public_path__ + "img/smiley_4.5f24ecca.svg";